import React, { useEffect, useState } from "react";
import IndividualCustomerApplication from "./IndividualCustomerApplication";
import CorporateCustomerApplication from "./CorporateCustomerApplication";
import { useDispatch } from "react-redux";
import { setApplicationType } from "../../../redux/slice/customer/customerSlice";
import { useSelector } from "react-redux";
import { fetchAllStates } from "./../../../redux/slice/staff/staffSlice";
import { useNavigate } from "react-router-dom";

const AddCustomer = () => {
  const { user } = useSelector((state) => state.auth);
  const { application_info } = useSelector((state) => state.customer);
  const [customerType, setCustomerType] = useState(
    application_info?.customer_type
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // console.log(user, "user");

  useEffect(() => {
    if (
      application_info?.customer_type?.length > 0 &&
      application_info?.isSetCustomerType == true
    ) {
      setCustomerType(application_info?.customer_type);
      dispatch(
        setApplicationType({
          customer_type: application_info?.customer_type,
          isSetCustomerType: false,
        })
      );
      dispatch(fetchAllStates());
      // dispatch(fetchAllOffices())
    }
  }, [application_info]);

  useEffect(() => {
    if (
      !user?.user_permissions?.some(
        (permission) => permission.name === "customer module"
      )
    ) {
      navigate("/admin/dashboard");
    }

    if (!customerType) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user?.user_permissions]);

  return (
    <>
      <div>
        {customerType === "Individual" && (
          <IndividualCustomerApplication customerType="Individual" />
        )}
      </div>
      <div>
        {customerType === "Corporate" && (
          <CorporateCustomerApplication customerType="Corporate" />
        )}
      </div>
    </>
  );
};

export default AddCustomer;
